<template>
  <div>
    <b-modal  ref="modalUnsavedChanges"
              :title="$t('Webportal.Dialog.UnsavedChanges.Title')"
              :ok-title="$t('Webportal.Dialog.UnsavedChanges.Ok')"
              :cancel-title="$t('Webportal.Dialog.UnsavedChanges.Cancel')"
              no-close-on-esc
              no-close-on-backdrop
              hide-header-close
              @ok="onUnsavedChangesOk"
              @cancel="onUnsavedChangesCancel">
      {{ $t("Webportal.Dialog.UnsavedChanges.Text") }}
    </b-modal>

    <b-modal  header-bg-variant="danger"
              ref="modalSaveError"
              :title="$t('Webportal.Dialog.SaveError.Title')"
              :ok-title="$t('Webportal.Dialog.SaveError.Ok')"
              ok-only
              @ok="onSaveErrorOk">
      {{ $t("Webportal.Dialog.SaveError.Text") }}
    </b-modal>

    <div class="animated fadeIn">
      <div class="container my-3">
        <b-nav tabs>
          <b-nav-item to="/administration/clientsettings">
            <font-awesome-icon :icon="['fas', 'building']" fixed-width />
            {{ $t("Webportal.Administration.ClientSettings") }}
          </b-nav-item>
          <b-nav-item to="/administration/surveysettings">
            <font-awesome-icon :icon="['fas', 'file']" fixed-width />
            {{ $t("Webportal.Administration.SurveySettings") }}
          </b-nav-item>
          <b-nav-item to="/administration/generalsettings">
            <font-awesome-icon :icon="['fas', 'cog']" fixed-width />
            {{ $t("Webportal.Administration.GeneralSettings") }}
          </b-nav-item>
          <b-nav-item v-if="hasDashboard()" to="/administration/cxsettings">
            <font-awesome-icon :icon="['fas', 'cogs']" fixed-width />
            &nbsp;{{ $t("Webportal.CXReporting") }}
          </b-nav-item>
          <b-nav-item v-if="hasDashboard()" to="/administration/cxclientsettings">
            <font-awesome-icon :icon="['fas', 'cogs']" fixed-width />
            &nbsp;{{ $t("Webportal.CXReporting") }} - {{ $t("Webportal.Administration.ClientSettings") }}
          </b-nav-item>
          <b-nav-item v-if="hasDashboard()" to="/administration/cxfirstaidsettings">
            <font-awesome-icon :icon="['fas', 'cogs']" fixed-width />
            &nbsp;{{ $t("Webportal.CXReporting") }} - {{ $t("Webportal.CX.FirstAid") }}
          </b-nav-item>
          <b-nav-item v-if="hasMarketReports && isMsmUser" to="/administration/marketreports">
            <font-awesome-icon :icon="['fas', 'cogs']" fixed-width />
            &nbsp;Market Reports
          </b-nav-item>
        </b-nav>
        <div class="tab-content mb-3" id="settings-pane">
          <div class="tab-pane fade show active" role="tabpanel">
            <router-view v-slot="{ Component }">
              <keep-alive>
                <component
                  :is="Component"
                  @unsavedChanges="componentUnsavedChanges"
                  @saveError="componentSaveError"
                />
              </keep-alive>
            </router-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppConfig from "@/mixins/AppConfig-APP_TARGET";

export default {
  name: "Administration",
  mixins: [AppConfig],
  data() {
    return {
      unsavedChangesCallback: null,
      saveErrorCallback: null,
    };
  },
  methods: {
    // Handle unsaved-changes dialog
    componentUnsavedChanges(isFormChanged, callback) {
      if (isFormChanged) {
        this.unsavedChangesCallback = callback;
        this.$refs.modalUnsavedChanges.show();
      } else {
        callback();
      }
    },
    onUnsavedChangesOk() {
      if (this.unsavedChangesCallback) this.unsavedChangesCallback();
      this.unsavedChangesCallback = null;
    },
    onUnsavedChangesCancel() {
      if (this.unsavedChangesCallback) this.unsavedChangesCallback(false);
      this.unsavedChangesCallback = null;
    },

    // Handle save-error dialog
    componentSaveError(callback) {

      this.saveErrorCallback = callback;
      this.$refs.modalSaveError.show();
    },
    onSaveErrorOk() {
      if (this.saveErrorCallback) this.saveErrorCallback();
      this.saveErrorCallback = null;
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.nav-tabs .nav-link.active) {
  background-color: var(--control-bg-color) !important;
  border-color: var(--bs-border-color);
  border-bottom: 2px solid var(--color-foreground);
  color: var(--color-foreground);
  font-weight: bold;
}
</style>

<style lang="scss" scoped>
:deep(.nav-tabs .nav-link.active) {
  background-color: var(--control-bg-color) !important;
  border-color: var(--bs-border-color);
  border-bottom: 2px solid var(--color-foreground);
  color: var(--color-foreground);
  font-weight: bold;
}
</style>
